import type {
  SplitLineRotateInOptions,
  SplitCharSlideUpOptions,
  SplitRotateX3dInOptions,
} from './split.types';

const defaultOptions = {
  minStaggerDuration: 0.05,
  maxStaggerDuration: 0.5,
  stagger: 0.05,
};

export const defaultSplitLineRotateInOptions: SplitLineRotateInOptions = {
  ...defaultOptions,
  splitType: 'lines',
  duration: 0.6,
  maxStaggerDuration: 0.6,
  y: '150%',
  rotation: 20,
  ease: 'power3.out',
  transformOrigin: '0 0',
};

export const defaultSplitCharSlideUpOptions: SplitCharSlideUpOptions = {
  ...defaultOptions,
  splitType: 'chars',
  y: '100%',
  duration: 0.4,
  minStaggerDuration: 0.025,
  maxStaggerDuration: 0.4,
  ease: 'quad.inOut',
  addInnerChild: true,
};

// transform: translate3d(0px, 0px, -2em) scale3d(0.9, 0.9, 1) rotateX(-94deg) rotateY(5deg) rotateZ(0deg) skew(-5deg, 0deg);
// transform-style: preserve-3d;
// opacity: 0;

export const defaultSplitRotateX3dInOptions: SplitRotateX3dInOptions = {
  ...defaultOptions,
  splitType: 'lines',
  duration: 0.7,
  autoAlpha: false,
  rotateX: -94,
  rotateY: 5,
  z: '-2em',
  scale: 0.9,
  skewX: -5,
  y: -5,
  ease: 'Power2.easeInOut',
  transformOrigin: '50% 0%',
  minStaggerDuration: 0.05,
  maxStaggerDuration: 0.5,
  clearProps: 'rotateX, rotateY, z, scale, skewX, y',
};

export const defaultSplitLineKaraokeOptions: SplitLineRotateInOptions = {
  ...defaultOptions,
  splitType: 'lines',
  duration: 3,
  maxStaggerDuration: 10,
  y: '150%',
  rotation: 20,
  ease: 'power3.out',
  transformOrigin: '0 0',
};
